export type MatchemPointsRules = {
  correct: number;
  matchPoint: number | undefined;
};

export const getMatchemPointsRulesText = (rules: MatchemPointsRules) => {
  if (!!rules.matchPoint) {
    return `You get ${rules.matchPoint} points per match point your pick gets, and an additional ${rules.correct} points if they win.`;
  }

  return `You get ${rules.correct} points per correct pick.`;
};
